import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import i18n from '../../i18n';
import TableBody from '@material-ui/core/TableBody';
import Icon from '@material-ui/core/Icon';
import React, {useState} from 'react';
import projectQueries from '../../queries/projectQueries';
import {withStyles} from '@material-ui/core';
import Query from 'react-apollo/Query';
import GraphQlLoading from '../GraphQl/Loading';
import GraphQlError from '../GraphQl/Error';
import ProjectStatusEdit from './ProjectStatusEdit';
import projectStatusMutations from '../../mutations/projectStatusMutations';
import {getMutationName} from '../Form/utils';
import Button from '@material-ui/core/Button';
import axios from "axios";
import Tooltip from "@material-ui/core/Tooltip";

const saveProjectStatus = async (projectStatus) => {

    if(projectStatus.default){
        const {data:prev} = await axios.put(`/config/deficiency-status/${projectStatus.id}`);
    }

    const mutation = projectStatus.id > 0 ? projectStatusMutations.updateProjectStatus : projectStatusMutations.createProjectStatus;
    const mutationName = getMutationName(mutation);
    const {data: result} = await window.apolloClient.mutate({mutation, variables: {...projectStatus}});

    return result[mutationName];
}

const deleteProjectStatus = async(id) => {
    const {data:deleted} = await axios.delete(`/config/deficiency-status/${id}`);
    return deleted;
}

const ProjectStatusList = (props) => {
    const [adds, setAdds] = useState({data: []});
    const [addState, setAddState] = useState(false);
    const [defaultState,setDefaultState] = useState(false);
    const [deleting,setDeleting] = useState(false);
    const [eventsList, setEventsList] = useState(props.events);
    const [restored, setRestored] = useState('');

    const changeDefault = e => {
        setDefaultState(e);
    }
    const changeAddState = e => {
        setAddState(e);
    }

    const deleteStatus = (id) => {
        setDeleting(true);
        deleteProjectStatus(id)
            .then(isDeleted => {
                isDeleted && setDeleting(false);
            })
    }
    // add or remove events from current event list
    const changeEventsList = (option,action) => {
        if(action === 'remove') {
            setEventsList( eventsList.filter(event => event !== option) );
        }
        if(action === 'restore') {
            if( !eventsList.includes(option) ) {
                setEventsList([...eventsList,option]);
                setRestored(option);
            }
        }
    };

    return (
        <React.Fragment>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell style={{width:'25%'}}>{i18n.get('project.status_form.name')}</TableCell>
                        <TableCell align={'center'}>{i18n.get('project.status_form.color')}</TableCell>
                        <TableCell align={'center'}>{i18n.get('project.status_form.closed')}</TableCell>
                        <TableCell align={'center'} style={{width:'15%'}}>{i18n.get('project.status_form.prio')}</TableCell>
                        <TableCell align={'center'}>
                            <Tooltip title={i18n.get('project.status_form.set_status_automatically')}>
                                <span>{i18n.get('project.status_form.default')}</span>
                            </Tooltip>
                        </TableCell>
                        <TableCell style={{width:'25%'}}>
                            <Tooltip title={i18n.get('project.status_form.set_status_after_event')}>
                                <span>{i18n.get('project.status_form.event')}</span>
                            </Tooltip>
                        </TableCell>
                        <TableCell align={'center'}>{i18n.get('project.actions')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>

                    <Query
                        query={projectQueries.allProjectStatus}
                    >
                        {({loading, error, data, refetch }) => {
                            if (loading) {
                                return <TableRow><TableCell colSpan={7}><GraphQlLoading/></TableCell></TableRow>;
                            }
                            if (error) {
                                return <TableRow><TableCell colSpan={7}><GraphQlError/></TableCell></TableRow>;
                            }

                            if (defaultState || addState || deleting) {

                                //changeDefault(false);
                                //changeAddState(false);
                                refetch();
                            }

                            let events = eventsList;
                            // compare used events with list of events and remove it to ensure unique using
                            if(data && data.projectstatuss && data.projectstatuss.data) {
                                let statusList = data.projectstatuss.data;
                                statusList.forEach(item => {
                                    if (item.event && events.includes(item.event)) {
                                        // if an event was deselected and restored in the eventsList then it is not removed from list
                                        if(item.event !== restored) {
                                            events = events.filter(event => event !== item.event);
                                        }
                                    }
                                });
                            }

                            return data.projectstatuss.data && data.projectstatuss.data.length > 0 &&
                                data.projectstatuss.data.map((status, idx) => {
                                        return (
                                            <ProjectStatusEdit
                                                key={`projectStatus_${idx}`}
                                                values={status}
                                                deleteStatus={deleteStatus}
                                                onChange={(status) => {
                                                    saveProjectStatus(status)
                                                        .then(e => {
                                                            changeDefault(!!e.default);
                                                        });
                                                }}
                                                eventsList={events}
                                                setEventsList={setEventsList}
                                                changeEventsList={changeEventsList}
                                                setRestored={setRestored}
                                            />
                                        );
                                    }
                                );
                        }}
                    </Query>

                    {adds && adds.data && adds.data.length > 0 && adds.data.map((status, idx) => (
                        <ProjectStatusEdit
                            key={`newProjectStatus_${idx}`}
                            values={status}
                            edit={true}
                            setAdds={setAdds}
                            onChange={(status) => {
                                saveProjectStatus(status)
                                    .then(() => {
                                        changeDefault(!!status.default);
                                        changeAddState(true);
                                        setAdds({data: []});
                                    });
                                }
                            }
                            eventsList={eventsList}
                            setEventsList={setEventsList}
                            changeEventsList={changeEventsList}
                            setRestored={setRestored}
                        />
                    ))}
                </TableBody>
            </Table>
            {adds.data && adds.data.length === 0 && (
                <Button
                    variant="contained" size="small"
                    onClick={() => {
                        adds.data.push({id: null, color: '', name: '', prio: 0, closed: false, default:false});
                        setAdds({data: adds.data});
                    }}
                    className={props.classes.spacing}
                >
                    <Icon>add</Icon> {i18n.get('project.status_form.add')}
                </Button>
            )}
        </React.Fragment>
    );
};

const styles = theme => ({
    spacing: {
        marginTop: theme.spacing.unit * 2
    },
    span: {
        display: 'inline',
        margin: '0 5px',
    },
});

export default withStyles(styles)(ProjectStatusList);
